import React from 'react';
import { CalendarStore } from '@uplift/store';
import { CalendarStoreContext } from '@uplift/contexts';

export const CalendarStoreProvider: React.FC<{
  calendarStore: CalendarStore;
}> = ({ calendarStore, children }) => {
  return (
    <CalendarStoreContext.Provider value={calendarStore}>
      {children}
    </CalendarStoreContext.Provider>
  );
};
